define('modules/page',[
	'require',
	'jquery',
	'widgets/widgets',
], function (require, $) {

	var _cache = {};
	var _widgets = {};
	var _controllers = {};

	var regex = {
		view: /^view-/
	};

	return {

		id: false,
		ready: false,
		url: null,

		setup: function () {

			if (this.ready) return this;

			this.$html = $('html');
			this.$body = $(document.body);

			if (window.location.hash.substr(1, 1) == '!')
				this.$html.removeClass('nav-enabled');

			this.set(null, $.proxy(this, 'onReady'), null, true);

			this.$win = $(window).on('popstate', $.proxy(this, 'onPopState'));
			this.$defaultContainer = $('#main');

			this.$win.on('resize', $.proxy(this, 'onResize'));

			return this;

		},

		onReady: function (controller) {

			// this.controller = controller.enable();

			if (this.id == 'view') {
				_cache[this.url] = this.controller.$el.html();
			}

			// this.setCurrent(this.id, url, true);

			this.ready = true;
			this.$html.addClass('ready');

			$.publish('pageReady', this.id);

			return this.controller;

		},

		get: function () {

			var classes, match;

			if (this.id) return this.id;

			classes = this.$html.attr('class');
			match = classes.match(/page\-([^ ]+)/);

			this.id = match ? match[1] : 'overview';

			return this.id;

		},

		set: function (id, cb, url, nopush) {

			var name, controller;

			if (id === this.id && (!url || this.url == url))
				return cb ? cb(this.controller) : this;

			id = id || this.get();

			this.$html
				.removeClass('page-' + this.id)
				.addClass('page-' + id);

			url = url || location.href.replace(document.baseURI, '');
			this.setCurrent(id, url, nopush);

			controller = _controllers[id];

			if (controller) {

				this.init(controller, cb);

			} else {

				name = 'controllers/' + this.id.replace('-', '/');
				require([name], $.proxy(function (controller) {
					this.init(controller, cb);
					_controllers[id] = controller;
				}, this));

			}

			return this;

		},

		init: function (controller, cb, id, url) {

			var widgets;

			this.deinit();

			if (cb) cb(controller);

			id = id || this.id;
			url = url || this.url;

			if (!controller.ready)
				controller.setup();
			else if (controller.update)
				controller.update();

			controller.enable();

			controller.$el.widgets()
				.addClass('view')
				.addClass('enabled')
				.removeClass('disabled');

			controller._url = url;

			this.controller = controller;

			$.publish('pageChange', [id, controller]);

			return this;

		},

		deinit: function (controller) {

			controller = controller || this.controller;
			if (!controller) return this;

			controller.$el.widgets('disable');

			_cache[controller._url] = this.getContainer(controller).contents();

			controller.disable();
			controller.$el.removeClass('enabled');
			controller.$el.addClass('disabled');

			this.contoller = null;

			return this;

		},

		load: function (url, id, nopush) {

			if (url === this.url) return;

			this.$body.addClass('page-change loading');

			// disable the current controller
			if (this.controller)
				this.deinit();

			// load content from cache / server
			if (_cache[url])
				this.onLoad(_cache[url], url, id, nopush);
			else
				$.ajax(url, {
					complete: $.proxy(function (req) {
						// _cache[url] = req.responseText;
						this.onLoad(req.responseText, url, id, nopush);
					}, this)
				});

		},

		onLoad: function (content, url, id, nopush) {

			this.set(id, $.proxy(function (controller) {

				var container = this.getContainer(controller)
					classes = container.attr('class').split(' ');

				container.empty()
					.append(content);

				$.each(classes, function (i, name) {
					if (regex.view.test(name))
						container.removeClass(name);
				});
				container.addClass('view-' + id);

				$.publish('pageLoad', id);

				this.$body.removeClass('loading');

				return this.controller;
			}, this), url, nopush);

		},

		setCurrent: function (id, url, nopush) {

			if (history.pushState && (!nopush || !this.ready))
				history[nopush ? 'replaceState' : 'pushState']({
					id: id,
					url: url
				}, "carve", url);

			// normalize url
			this._parser = this._parser || document.createElement('a');
			this._parser.href = url;

			this.url = this._parser.pathname;
			this.id = id;

			this.track();

		},

		getContainer: function (controller) {

			var $container = controller.$container ? controller.$container :
				(controller.container ? $(controller.container) : this.$defaultContainer);

			controller.$container = $container;
			return $container;

		},

		onPopState: function (e) {

			var state = e.originalEvent.state;
			if (!state) return;

			if (state.url && _cache[state.url])
				this.load(state.url, state.id, true);
			else
				this.set(state.id, null, state.url, true);

		},

		track: function () {

			// if enabled use google analytics to track page view

			if (!window.ga || !this.ready) return;
			ga('send', 'pageview', this.url);

		},

		onResize: function () {

			if (this.resizeTimer)
				clearTimeout(this.resizeTimer);

			this.resizeTimer = setTimeout($.proxy(function() {
				this.$win.trigger('resized');
				this.resizeTimer = null;
			}, this), 200);

		}

	};

});
